<template>
  <section>
    <b-modal
      id="import-bom-modal"
      ref="import-bom-modal"
      size="sm"
      @shown="logStatus = 'Waiting for files to be imported...'; onImporting = true"
      @hide="resetModel"
      title="Import BOM"
      no-close-on-backdrop
    >
      <div class="modal-body">
        <a href="/files/BOMImportFile.xlsx" download>
          <i class="fa fa-file"></i>
          Download Template File
        </a>

        <b-form-group  label="Customer" style="grid-column: 3/5; grid-row: 1;" class="mt-1 mr-2 required">
          <b-input-group size="sm">
            <b-input-group-append v-if="checkClaim(CAN_ADD_COMPANY) || checkClaim(CAN_EDIT_COMPANY)">
              <b-button variant="light" @click="$refs.addNewCompany.showModal()">
                <i v-if="checkClaim(CAN_ADD_COMPANY)" v-show="this.selectedAccount.id == undefined || this.selectedAccount.id == null || this.selectedAccount.id == 0" class="customer-lookup--plus fa fa-plus"></i>
                <i v-if="checkClaim(CAN_EDIT_COMPANY)" v-show="this.selectedAccount.id > 0" class="customer-lookup--plus fa fa-pencil"></i>
              </b-button>
            </b-input-group-append>
            <vue-simple-suggest
              id="requirement-customer"
              class="suggest-input form-control "
              :class="{ 'is-invalid': this.customerNameTouched
                    && ($v.formData.companyId.$required || !chosenName) }"
              :styles="autoCompleteStyle"
              :list="getListOfNames"
              :max-suggestions="20"
              :min-length="3"
              :debounce="200"
              v-model="chosenName"
              :filter-by-query="true"
              value-attribute="id"
              display-attribute="name"
              @select="onSuggestNameSelect"
              @input="onSuggestNameChange"
              @blur="onCompanyBlur"
              @request-done="onRequestDone"
              autocomplete="off"
            >
              <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                <span>Loading Customers...</span>
              </div>
            </vue-simple-suggest>
          </b-input-group>
          <div class="invalid-feedback">
            <div v-if="!$v.formData.companyId.required && !chosenName">Customer is required</div>
          </div>
        </b-form-group>

        <b-form-group label="Contact" style="grid-column: 5; grid-row: 1;" class="mt-1 mr-2 required">
          <b-input-group size="sm">
            <b-input-group-append v-show="selectedAccount.id > 0">
              <b-button variant="light" @click="$refs.addNewContact.newContact()" >
                <i class="customer-lookup--plus fa fa-plus"></i>
              </b-button>
            </b-input-group-append>
            <b-form-select
              v-model="formData.contactId"
              :class="{ 'is-invalid': $v.formData.contactId.$error }"
              @blur="$v.formData.contactId.$touch()"
              :disabled="!(selectedAccount.id)"
            >
              <option
                v-for="(select, index) in sortSelect(contacts,'firstName')"
                :key="index"
                :value="select.id"
              >{{ select.firstName + ' ' + select.lastName }}</option>
            </b-form-select>
          </b-input-group>
          <div class="invalid-feedback">
            <div v-if="!$v.formData.contactId.required">Contact is required</div>
          </div>
        </b-form-group>

        <b-form-group label="BOM Import File" class="required mt-2">
          <b-form-file
            multiple
            v-model="formData.filesUpload"
            :disabled="isSaving || !onImporting"
            :file-name-formatter="formatNames"
            accept=".xlsx"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-form-invalid-feedback>Please select valid file to import BOM.</b-form-invalid-feedback>
        </b-form-group>
        <br/>
        <b-form-group>
          <b-textarea
            v-model="logStatus"
            disabled
            :style="`width: 100%`"
            :rows="5"
          />
        </b-form-group>
      </div>
      <template slot="modal-footer">
          <b-button @click="$bvModal.hide('import-bom-modal')">Close</b-button>
          <b-button variant="primary" @click="onImportBOM" v-if="onImporting" :disabled="isSaving">Import</b-button>
      </template>
    </b-modal>


    <edit-company
      ref="addNewCompany"
      hiddenButton
      :id="selectedAccount.id"
      :companyName="chosenName"
      @currentCompany="onCurrentCompany"
      @cancel="chosenName = ''"
    />

    <edit-contact
      :companyId="selectedAccount.id"
      ref="addNewContact"
      :inlineButton="true"
      :isQuickAdd="true"
      @created="onContactCreated"></edit-contact>

  </section>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import VueSimpleSuggest from 'vue-simple-suggest';
  import { required } from 'vuelidate/lib/validators';
  import { AUTO_COMPLETE_STYLES, CUSTOMER_ID } from '@/shared/constants';
  import EditCompany from '@/pages/Company/components/EditCompany';
  import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';

  export default {
    components: {
      VueSimpleSuggest,
      EditCompany,
      EditContact
    },
    data() {
      return {
        isSaving: false,
        formData: {
          companyId: null,
          filesUpload: null,
        },
        logStatus: null,
        onImporting: false,
        selectedAccount: {},
        customerNameTouched: '',
        chosenName: '',
        companiesList: [],
        isLoading: false,
        autoCompleteStyle: AUTO_COMPLETE_STYLES,
      };
    },
    validations: {
      formData: {
        companyId: { required },
        contactId: { required },
        filesUpload: { required },
      },
    },
    computed: {
      ...mapGetters('requirementAdd',[
        'contacts'
      ]),
    },
    methods: {
      ...mapActions('requirementAdd', ['importBOM', 'getContacts']),
      ...mapActions('companies', [
        'getByNameAndAccountType'
      ]),
      formatNames(files) {
        return files[0].name;
      },
      resetModel(){
          this.formData = {
              companyId: null,
              filesUpload: null,
          };
          this.chosenName= '';
          this.selectedAccount = {}
      },
      async onImportBOM(e) {
        e.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        }
        let formData = new FormData();
        formData.append('companyId', this.formData.companyId);
        formData.append('contactId', this.formData.contactId);
        this.formData.filesUpload.forEach(element => {
          formData.append('files[]', element, element.name);
        });
        this.isSaving = true;
        this.logStatus += `\nStarted importing BOM...`
        const result = await this.importBOM(formData).catch((res) => {
          this.isSaving = false;
          this.resetModel()
          this.logStatus += `\nThere's an error encountered during import. Please check errors within the import file.`
        });

        if (result != null) {
          this.logStatus += `\n---------------------------------------------------------`
          this.logStatus += `\nSuccessfully imported BOM: ${result.successCount}`
          this.logStatus += `\nFailed imported BOM: ${result.failCount}`
          this.resetModel()
        }

        this.isSaving = false;
        this.onImporting = false;
        // this.$bvModal.hide(this.modalId);
        this.$emit('refreshGrid');
      },

      async getListOfNames(name) {
        this.companiesList = await this.getByNameAndAccountType({
          typeId: CUSTOMER_ID, name});
        return this.companiesList;
      },
      async onSuggestNameSelect(suggestion) {
        // console.log(suggestion, "Suggestion")
        this.setSelectedAccount(suggestion.id, suggestion.name);
        this.formData.companyId = suggestion.id;

        this.getContacts(suggestion.id);
      },
      setSelectedAccount(id, name) {
        this.selectedAccount = {
          id: id,
          name: name
        }
      },
      async onSuggestNameChange() {
        this.isLoading = true;
        if (this.selectedAccount.name && this.chosenName !== this.selectedAccount.name) {
          this.selectedAccount = { id: 0 }
          this.formData.companyId = null;
          this.$v.formData.companyId.$touch();
        }
      },
      async onCompanyBlur() {
        this.customerNameTouched = true;
        if(this.chosenName) {
          if (this.companiesList.length > 0) {
            const findIndex = this.companiesList.findIndex(x => this.chosenName.toLowerCase() == x.name.toLowerCase());

            if (findIndex > -1) {
              this.onSuggestNameSelect(this.companiesList[findIndex]);
            } else {
              this.companyNotFoundConfirmation();
            }
          } else {
            this.companyNotFoundConfirmation();
          }
        }
      },
      async companyNotFoundConfirmation() {
        const deleteConfirmed = await this.openConfirmBox({okTitle: 'Continue',message: `${this.chosenName} is not in the database. Press Continue to add them.`});
        if (deleteConfirmed) {
          this.selectedAccount = {};
          this.formData.companyId = null;
          this.$refs.addNewCompany.showModal();
        } else {
          this.chosenName = "";
        }
      },
      onRequestDone() {
        this.isLoading = false;
      },
      async onCurrentCompany(val) {
        this.setSelectedAccount(val.id, val.name);
        this.formData.companyId = val.id;
        this.chosenName = val.name;
      },
      async onContactCreated(id) {
        await this.getContacts(this.formData.companyId);
        this.formData.contactId = id;
      },
    },
  };
</script>
